'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cs = require('classnames');
var formik = require('formik');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cs__default = /*#__PURE__*/_interopDefaultLegacy(cs);

const isFunction = (value) => {
    return typeof value === "function";
};
const FormContainer = ({ validationSchema, initialValues, onSubmit, children, validateOnChange = true, validateOnBlur = true, className, ...props }) => {
    const classes = cs__default['default']("", {
        [`${className}`]: className,
    });
    if (isFunction(children)) {
        return (React__default['default'].createElement(formik.Formik, Object.assign({ initialValues: initialValues, validationSchema: validationSchema, onSubmit: onSubmit, validateOnChange: validateOnChange, validateOnBlur: validateOnBlur }, props), (formikProps) => (React__default['default'].createElement(formik.Form, { className: classes }, children(formikProps)))));
    }
    return (React__default['default'].createElement(formik.Formik, Object.assign({ initialValues: initialValues, validationSchema: validationSchema, onSubmit: onSubmit, validateOnChange: validateOnChange, validateOnBlur: validateOnBlur }, props),
        React__default['default'].createElement(formik.Form, { className: classes }, children)));
};

exports.default = FormContainer;
exports.isFunction = isFunction;
